// extracted by css-extract-rspack-plugin
export default {"cls1":"useMenuActions-cls1_ZQV","cls2":"useMenuActions-cls2_cuN useMenuActions-cls1_ZQV"};